import { NgModule } from '@angular/core';
import { OptionModuleInReply } from '../../../../reply';
import { OptionAfterschoolComponent } from './option-afterschool.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [OptionModuleInReply, FormsModule],
  declarations: [OptionAfterschoolComponent],
  exports: [OptionAfterschoolComponent]
})
export class OptionAfterschoolModule {}
